
import { Box, Grid, Tooltip } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import { isTSEnumMember } from "@babel/types";

export default function () {
    const css = `
// #printView {
//   display: none ;
// }

@media print {
    @page{
        size: a3 !important;
    }
  #division {
    break-inside: avoid;
    page-break-before: auto;
    page-break-after: auto;
    padding-top:50px;
  }
  img {
    page-break-inside: avoid;
    max-height: 120vh !important;
    max-width: 100%;
    width: auto;
  }
  table{
    table-layout: fixed;
    overflow-wrap: anywhere;
   }
  #detailInfo{
    max-width: fit-content !important;
   
  }
//   @page {
//     size: A4;
//     margin:0 !important;
//   }
  #screenView  {
    display: none;
  }
  #printView {
    display: block ;
  }
  #kt_header{
    display: none;
  }
  #kt_subheader{
    display:none;
  }
  #kt_header_mobile{
    display:none;
  }
  #no_print{
    display:none;
  }

}

`

    const history = useHistory<{ printedDataState: any, id: any }>();
    const printedData = history.location.state != null ? history.location.state.printedDataState : null;
    if (printedData == null || printedData == undefined) {
        history.push("/loan")
    }

    const [pages, setPages] = useState<number | undefined>(undefined);
    return (
        <>
            <div style={{ height: "100vh" }}>
                <style>{css}</style>
                {/* <iframe style={{overflow:"hidden"}}  src="https://api.app.refactor.golrangonline.ir/api/Document/Content/35af486c-95f0-41df-b01e-9aee31ff4e6f#toolbar=0"  width="100%" height="100%"  >

                </iframe> */}
                <Grid container>
                    <Grid item xs={12}>
                        <div id="screenView">
                            <Box
                                sx={{
                                    marginRight: "4vh",
                                    marginBottom: "4vh",
                                    direction: "rtl",
                                    overflowX: "none",
                                }}
                            >
                                <Grid container spacing={2}>
                                    <Grid
                                        item
                                        xs={4}
                                        className="centerVertical"
                                    >
                                        {/* <Tooltip title="پرینت" arrow> */}
                                        <PrintOutlinedIcon
                                            onClick={() => window.print()}
                                            className="colorTitle iconStyle cursorPointer"
                                        />
                                        {/* </Tooltip> */}
                                    </Grid>
                                </Grid>
                            </Box>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <div id="printView" style={{ marginRight: "4vh", marginLeft: "4vh" }}>
                            {(printedData != null && printedData != undefined) ? (
                                (printedData.map((item: any) => (
                                    <>
                                        {item.showComponent ? item.child : <></>}
                                        {item.showDocuments == true && item.showDocumentsBottomOfPage == false ? item.documents : <></>}
                                    </>

                                )))
                            ) : <></>
                            }
                            {(printedData != null && printedData != undefined) ? (
                                (printedData.map((item: any) =>
                                    item.showDocuments == true && item.showDocumentsBottomOfPage ?
                                        item.documents
                                        :
                                        <></>

                                )
                                )

                            ) : <></>
                            }

                        </div>
                    </Grid>
                </Grid>

                {/* <div style={{ width: "100%", justifyContent: "center", display: "flex" }}>
                    <Document
                        file={{ url: "https://api.app.refactor.golrangonline.ir/api/Document/Content/d5394d31-2d5e-4dd1-a964-dff056abf077" }}
                        onLoadSuccess={(numPages: any) =>
                            setPages(numPages._pdfInfo.numPages)}
                    >
                        {pages != undefined && pages > 1 ?
                            Array.from({ length: pages }).map((element, index) =>
                                < Page pageNumber={index + 1} />)
                            : <></>
                        }
                    </Document>
                </div> */}
            </div>

        </>
    );
}

